import { type Dayjs, isDayjs } from 'dayjs'
import { type DateType } from 'react-native-ui-datepicker'

export function getDateFromDateType(date: DateType | Dayjs | null | undefined): Date | undefined {
  if (date instanceof Date) {
    return date
  }

  if (isDayjs(date)) {
    return date.toDate()
  }

  if (typeof date === 'string' || typeof date === 'number') {
    const parsedDate = new Date(date)

    if (Number.isNaN(parsedDate.getTime())) {
      return undefined
    }

    return parsedDate
  }

  return undefined
}
